import Vue from 'vue';
import VueRouter from 'vue-router';
import paths from './paths';
import store from '@/store';

import * as HANDLERS from '@/helpers/types/handlers';
import eventBus from 'vue-option-events';

Vue.use(VueRouter);

const router = new VueRouter({
  base: '/',
  mode: 'hash',
  routes: paths
  // suppressTransitionError: true
});

router.beforeEach(function(to, from, next) {
  const isPublicRoute = to.matched.some(route => route.meta.public);
  const token = localStorage.getItem(store.getters['authentication/getConfig'].VUE_APP_TOKEN_KEY);

  if (!isPublicRoute && !token) {
    return next({ path: '/login' });
  }

  if (to.path === '/login' && token) {
    return next({ path: from.path });
  }

  if (to.meta.title) {
    document.title = to.meta.title;
  }

  eventBus.$emit(HANDLERS.SHOW_BACKGROUND, {});

  next();
});

export default router;
